import { Box } from '@chakra-ui/react';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { EngagementSurveyReportLineChart } from './EngagementSurveyReportLineChart';
import { EngagementSurveyReportsGrid } from './EngagementSurveyReportsGrid';

const EngagementManageIntent = ({ gridRef }) => (
  <Box>
    <Box p={checkNewNavEnabled() ? 0 : 4} mt={checkNewNavEnabled() ? 1 : 0}>
      <Box>
        <Box mb="8px">
          <EngagementSurveyReportLineChart />
        </Box>
        <PaperWithShadow p={3} mb={1} overflowX="auto" minHeight="300px">
          <EngagementSurveyReportsGrid gridRef={gridRef} />
        </PaperWithShadow>
      </Box>
    </Box>
  </Box>
);

export { EngagementManageIntent };
